import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { VerseBlock } from "@/components/VerseBlock";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export function BrowseIssues() {
  const [cats, setCats] = useState([]);
  const [busy, setBusy] = useState("");
  const nav = useNavigate();
  useEffect(() => { api.get("/categories").then((r) => setCats(r.data)); }, []);

  const go = async (slug) => {
    setBusy(slug);
    try { const { data } = await api.post("/wisdom-path", { issues: [slug], situation: "" }); nav("/wisdom-path", { state: { result: data } }); }
    catch { toast.error("Could not load."); } finally { setBusy(""); }
  };

  const groups = [...new Set(cats.map((c) => c.group))];
  return (
    <div className="max-w-6xl mx-auto px-5 sm:px-8 py-12">
      <h1 className="font-serif-display text-4xl text-[#0F172A] mb-2">Browse by Issue</h1>
      <p className="text-[#475569] mb-10">Choose what you're facing to receive an instant Wisdom Path.</p>
      {groups.map((g) => (
        <div key={g} className="mb-10">
          <h2 className="text-xs uppercase tracking-widest text-[#B8912F] mb-4">{g}</h2>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
            {cats.filter((c) => c.group === g).map((c) => (
              <button key={c.slug} data-testid={`browse-issue-${c.slug}`} onClick={() => go(c.slug)}
                className="text-left rounded-xl border border-[#E2E8F0] bg-white px-4 py-4 hover:border-[#2C4C3B] transition-colors flex items-center justify-between">
                <span className="text-[15px] text-[#334155]">{c.label}</span>
                {busy === c.slug && <Loader2 className="w-4 h-4 animate-spin text-[#2C4C3B]" />}
              </button>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

export function BrowseAll() {
  const [verses, setVerses] = useState([]);
  const [q, setQ] = useState("");
  const [chapter, setChapter] = useState("");
  const load = () => { api.get("/proverbs", { params: { q, chapter: chapter || undefined } }).then((r) => setVerses(r.data)); };
  useEffect(() => { load(); }, []);
  return (
    <div className="max-w-3xl mx-auto px-5 sm:px-8 py-12">
      <h1 className="font-serif-display text-4xl text-[#0F172A] mb-2">All Proverbs</h1>
      <p className="text-[#475569] mb-6">Every verse in our curated database (World English Bible).</p>
      <div className="flex flex-wrap gap-2 mb-8">
        <input data-testid="browse-search-input" value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={(e) => e.key === "Enter" && load()}
          placeholder="Search word or reference…" className="flex-1 min-w-[180px] rounded-full border border-[#E2E8F0] px-4 py-2.5 focus:outline-none focus:border-[#2C4C3B]" />
        <input data-testid="browse-chapter-input" value={chapter} onChange={(e) => setChapter(e.target.value)} type="number" placeholder="Ch."
          className="w-20 rounded-full border border-[#E2E8F0] px-4 py-2.5 focus:outline-none focus:border-[#2C4C3B]" />
        <button data-testid="browse-search-btn" onClick={load} className="px-5 py-2.5 rounded-full bg-[#2C4C3B] text-white font-medium">Search</button>
      </div>
      <p className="text-sm text-[#94A3B8] mb-4">{verses.length} verses</p>
      <div className="space-y-5">{verses.map((v, i) => <VerseBlock key={v.id} v={v} index={i} />)}</div>
    </div>
  );
}
